import * as types from "./actionsTypes";

export function setTokens(data) {
  return {
    type: types.AUTH_SET_TOKEN,
    data: data,
  };
}

export function delTokens() {
  return {
    type: types.AUTH_DEL_TOKEN,
  };
}

export function setRememberMe(email, password) {
  return {
    type: types.AUTH_SET_REMEMBER_ME,
    data: {
      email: email,
      password: password,
    },
  };
}

export function delRememberMe() {
  return {
    type: types.AUTH_DEL_REMEMBER_ME,
  };
}

export function setLocale(locale) {
  return {
    type: types.AUTH_SET_LOCALE,
    data: locale,
  };
}

export function resetLocale() {
  return {
    type: types.AUTH_RESET_LOCALE,
  };
}

export function refresh() {
  return {
    type: types.AUTH_START_REFRESH,
  };
}

export function refreshed() {
  return {
    type: types.AUTH_END_REFRESH,
  };
}
